module.exports = __webpack_public_path__ + "static/media/error404recipebook.6c7c5a21.jpg";